import { Component, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MessageService } from 'primeng/api';
import { FuelFormSubmission, TruckOption } from '../interfaces';
import { FuelService } from '../services/fuel.service';

@Component({
  selector: 'app-fuel-form',
  templateUrl: './fuel-form.component.html',
  styleUrls: ['./fuel-form.component.scss'],
})
export class FuelFormComponent implements OnInit {
  @ViewChild('fuelForm') fuelForm!: NgForm;

  truckOptions: TruckOption[] = [];
  isLoadingTrucks = false;

  selectedTruck: TruckOption | null = null;
  selectedInvoiceDate: Date | null = null;
  isSubmitting = false;

  formData: Partial<FuelFormSubmission> = {
    invoiceNumber: '',
    Vendor: '',
    City: '',
    State: '',
    PostalCode: '',
    Quantity: undefined,
  };

  constructor(
    private fuelService: FuelService,
    private messageService: MessageService
  ) {}

  ngOnInit(): void {
    this.loadTruckList();
  }

  loadTruckList(): void {
    this.isLoadingTrucks = true;
    this.fuelService.getTruckList().subscribe({
      next: (trucks) => {
        this.truckOptions = trucks;
        this.isLoadingTrucks = false;
      },
      error: (err) => {
        console.error('Failed to load truck list:', err);
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail: 'Failed to load truck list. Please refresh the page.',
        });
        this.isLoadingTrucks = false;
      },
    });
  }

  isFormValid(): boolean {
    return !!(
      this.selectedTruck &&
      this.selectedInvoiceDate &&
      this.formData.Vendor &&
      this.formData.City &&
      this.formData.State &&
      this.formData.PostalCode &&
      this.formData.Quantity && this.formData.Quantity > 0
    );
  }

  onSubmit(): void {
    if (!this.isFormValid()) {
      this.messageService.add({
        severity: 'error',
        summary: 'Validation Error',
        detail: 'Please fill in all required fields.',
      });
      return;
    }

    const invoiceDateStr = this.selectedInvoiceDate
      ? this.selectedInvoiceDate.toLocaleDateString('en-US', {
          year: 'numeric',
          month: '2-digit',
          day: '2-digit',
        })
      : undefined;

    const payload: FuelFormSubmission = {
      truckNumber: this.selectedTruck?.value,
      invoiceNumber: this.formData.invoiceNumber || undefined,
      InvoiceDate: invoiceDateStr,
      Vendor: this.formData.Vendor?.toUpperCase(),
      City: this.formData.City?.toUpperCase(),
      State: this.formData.State?.toUpperCase(),
      PostalCode: this.formData.PostalCode,
      Quantity: this.formData.Quantity,
    };

    this.isSubmitting = true;
    this.fuelService.submitFuelEntry(payload).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: 'Success',
          detail: 'Fuel entry submitted successfully!',
        });
        this.resetForm();
        this.isSubmitting = false;
      },
      error: (err) => {
        const detail =
          err.status === 409
            ? 'This fuel entry already exists in the system.'
            : 'Failed to submit fuel entry. Please try again.';
        this.messageService.add({
          severity: 'error',
          summary: 'Error',
          detail,
        });
        this.isSubmitting = false;
      },
    });
  }

  resetForm(): void {
    this.selectedTruck = null;
    this.selectedInvoiceDate = null;
    this.formData = {
      invoiceNumber: '',
      Vendor: '',
      City: '',
      State: '',
      PostalCode: '',
      Quantity: undefined,
    };
    if (this.fuelForm) {
      this.fuelForm.resetForm();
    }
  }
}
